import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilterIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M3 5h18l-7 8v6l-4-2v-4z" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

FilterIcon.displayName = 'FilterIcon';
